export default {
  AllApprovers: 'allApproversForOrders',
  FirstApprover: 'firstApproverForOrders',
}
